interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

export default function Sidebar({ activeTab, setActiveTab }: SidebarProps) {
  const menuItems = [
    { id: 'overview', label: '概要', icon: 'ri-dashboard-line' },
    { id: 'materials', label: '材料データ', icon: 'ri-box-3-line' },
    { id: 'construction', label: '施工データ', icon: 'ri-tools-line' },
    { id: 'stores', label: '店舗データ', icon: 'ri-store-2-line' },
  ];

  return (
    <aside className="w-64 bg-white border-r border-gray-200/80 flex flex-col">
      <div className="h-16 flex items-center px-6 border-b border-gray-200/80">
        <h1 className="text-xl font-bold text-gray-900">XR CMS</h1>
      </div>
      
      <nav className="flex-1 px-3 py-6 space-y-1">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all whitespace-nowrap cursor-pointer ${
              activeTab === item.id
                ? 'bg-teal-500 text-white shadow-sm'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-200/80">
        <div className="flex items-center gap-3 px-3 py-2">
          <div className="w-9 h-9 rounded-full bg-teal-500 flex items-center justify-center text-white font-semibold">
            A
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">管理者</p>
            <p className="text-xs text-gray-500 truncate">admin@solize.com</p>
          </div>
        </div>
      </div>
    </aside>
  );
}
